import { MenuList } from "@reach/menu-button";
import styled, { css } from "styled-components";
import { ButtonStyledComponent } from "components/button/button.style";

export const MenuOptionContainer = styled.div<{ visible: boolean; top?: string; left?: string }>`
   background-color: #fff;
   position: absolute;
   min-width: 150px;
   z-index: 100;
   box-shadow: 0 3px 10px rgb(0 0 0 / 15%);
   opacity: 0;
   visibility: hidden;
   transform: translateY(-15px);
   transition: transform 220ms ease-out, opacity 220ms ease-in;

   &.visible {
      transform: translateY(0px);
      opacity: 1;
      visibility: visible;
   }

   ${ButtonStyledComponent} & {
      background: #fff;
      font-weight: 400;
   }

   ${({ visible }) =>
      visible &&
      css`
         opacity: 1;
         visibility: visible;
      `}

   .option {
      width: 100%;
      padding: 7px 10px;
      font-size: 1.35rem;
      cursor: pointer;
      text-align: left;

      ${ButtonStyledComponent} &:hover {
         opacity: 1;
      }

      &:not(:last-child) {
         border-bottom: 1px solid #4371bf14;
      }

      &.delete-option:hover {
         background: red;
      }

      &:hover {
         color: #fff;
         font-weight: 500;
         background-color: ${({ theme }) => theme.colors?.primary};
      }
   }
`;

export const MenuContainer = styled.div<{ noMargin?: boolean }>`
   .menu-button {
      background: none;
      border: none;
      display: inline-flex;
      padding: 0;
      width: auto;
      margin-left: ${({ noMargin }) => (noMargin ? "0px" : "14px")};
      cursor: pointer;

      &:hover,
      &:focus {
         background-color: inherit;
      }

      &:disabled {
         cursor: not-allowed;
         opacity: 0.4;
      }
   }

   @keyframes slide-down {
      0% {
         opacity: 0;
         transform: translateY(-10px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }

   .slide-down[data-reach-menu-list],
   .slide-down[data-reach-menu-items] {
      border-radius: 5px;
      animation: slide-down 0.2s ease;
   }

   .slide-down {
      > [data-reach-menu-item] {
         width: 100%;
         padding: 7px 10px;
         font-size: 1.35rem;
         cursor: pointer;
         text-align: left;
         background: red;
      }
   }
`;

export const MyMenuList = styled(MenuList)`
   border: none;
   background: #fff;
   box-shadow: 0 3px 10px rgb(0 0 0 / 15%);
   width: 150px;
   padding: 5px 0;
   animation: slide-down 0.2s ease;
   z-index: 501;
   position: relative;
   z-index: 8000;

   > [data-reach-menu-item] {
      &:not(:last-child) {
         border-bottom: 1px solid #4371bf14;
      }
   }

   > [data-reach-menu-item][data-selected] {
      color: #fff;
      font-weight: 500;
      background-color: ${({ theme }) => theme.colors?.primary};
   }
`;

export const ChevronMenuList = styled(MenuList)`
   border: none;
   background: #fff;
   box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.12);
   width: 245px;
   padding: 5px 0;
   animation: slide-down 0.2s ease;
   z-index: 5000;
   position: relative;
   z-index: 8000;
   border-radius: 10px;

   > [data-reach-menu-item] {
      &:not(:last-child) {
         border-bottom: 1px solid #4371bf14;
      }
   }

   > [data-reach-menu-item][data-selected] {
      color: initial;
      font-weight: 500;
      background-color: rgba(53, 120, 229, 0.1);
   }
`;

export const MenuTitle = styled.div`
   padding: 18px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   .title {
      color: #444;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
   }
`;

export const DeclineOption = styled.div`
   display: flex;
   align-items: center;
   gap: 6px;
   .circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #b62953;
   }
   .name {
      color: #b62953;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
   }
`;

export const AcceptOption = styled.div`
   display: flex;
   align-items: center;
   gap: 6px;
   .circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #29b67a;
   }
   .name {
      color: #29b67a;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
   }
`;
